export default __webpack_public_path__ + "static/media/blurTwo.d0d764a4.png";